export enum PackageSizeEnum {
    SMALL = 'SMALL',    // max 100 cm x 50 cm x 50 cm
    LARGE = 'LARGE'     // více než 100 cm x 50 cm x 50 cm
}
